export const halfOfInteger = 0.5
export const decimalOfInteger = 0.001
export const roundingBase = 1 / decimalOfInteger

export const FLOATING_POINT_TOLERANCE = 1e-6
const NUMBER_REMAINDER_ROUNDING_BASE = 10000

export const getNumberRemainder = (num: number, decimal: number): number =>
  ((num * NUMBER_REMAINDER_ROUNDING_BASE) % (decimal * NUMBER_REMAINDER_ROUNDING_BASE)) / NUMBER_REMAINDER_ROUNDING_BASE

export const roundUpWholeInteger = (num: number): number => Math.ceil(num)
export const isWholeInteger = (num: number): boolean => num % 1 === 0

export const roundHalfInteger = (num: number): number => Math.round(num * 2) / 2
export const isHalfInteger = (num: number): boolean => num % halfOfInteger === 0

export const roundToInterval = (num: number, interval: number): number => (
  roundDecimalInteger(Math.round(num / interval) * interval)
)

export const roundDecimalInteger = (num: number): number => Math.round(num * roundingBase) / roundingBase
export const roundUpDecimalInteger = (num: number): number => Math.ceil(num * roundingBase) / roundingBase

export const isDecimalInteger = (num: number): boolean => {
  const remainder = getNumberRemainder(num, decimalOfInteger)
  return (
    Math.abs(remainder) < FLOATING_POINT_TOLERANCE ||
    Math.abs(remainder - decimalOfInteger) < FLOATING_POINT_TOLERANCE
  ) // need to account for floating point precision issues
}

export const roundToPrecision = (val: number, precision: number = 0): number => {
  const factor = 10 ** precision
  return Math.round(val * factor) / factor
}

export const roundDecimal = (num: number): number => roundToPrecision(num, 2)
export const roundHundred = (num: number): number => roundToPrecision(num, 3)
